module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Curtains-990dc9eb77a0166b29e3a3cf90601fc4.svg";